import { useState } from 'react';
import api from '../../utils/api';

export default function AdminNewsletter() {
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState('');

  const handleSend = async () => {
    if (!subject.trim() || !content.trim()) return;
    setSending(true);
    try {
      const res = await api.post('/api/admin/newsletter/broadcast', {
        subject: subject.trim(),
        content: content, // you can write HTML directly
      });
      setResult(res.data);
      setSubject('');
      setContent('');
    } catch (err) {
      setResult('Failed to send newsletter.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Send Newsletter</h2>

      <div className="space-y-4 bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
          <input
            type="text"
            value={subject}
            onChange={e => setSubject(e.target.value)}
            placeholder="Summer Sale starts now!"
            className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            HTML Content
            <span className="text-xs text-gray-400 ml-2">(You can use HTML tags)</span>
          </label>
          <textarea
            value={content}
            onChange={e => setContent(e.target.value)}
            rows={12}
            placeholder="<h2>Big Sale</h2><p>Check out our new arrivals...</p>"
            className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-black"
          />
        </div>

        <button
          onClick={handleSend}
          disabled={sending || !subject.trim() || !content.trim()}
          className="w-full bg-black text-white py-3 rounded-xl font-semibold hover:bg-gray-900 transition disabled:opacity-50"
        >
          {sending ? 'Sending…' : 'Send to All Subscribers'}
        </button>

        {result && (
          <p className={`text-sm text-center ${result.includes('Failed') ? 'text-red-500' : 'text-emerald-600'}`}>
            {result}
          </p>
        )}
      </div>
    </div>
  );
}